import OperationTypeIcon from "./OperationTypeIcon";
import CaretDownIcon from "@/lib/CaretDownIcon";
import Dropdown from "@/lib/Dropdown";
import Menu from "@/lib/Menu";
import {
  useCreateOperation,
  useDeleteOperation,
  useFetchSuggestOperations,
} from "@/lib/queries/hooks";
import { Operation } from "./types";
import { useParams } from "react-router";

export default function SwapMaterialCalculator({
  operation,
}: {
  operation: Operation;
}) {
  const { data: suggestOperations = [] } = useFetchSuggestOperations();
  const materialOperations = suggestOperations.filter(
    (op) => op.general_type === "material",
  );

  const { teamSlug, partId } = useParams();
  const { mutate: deleteOperation } = useDeleteOperation();
  const { mutate: createOperation } = useCreateOperation();

  const iconAndName = (
    <div
      className="flex gap-2 items-center"
      data-operation-type={operation.type}
    >
      <OperationTypeIcon operationType={operation.type} className="size-4" />
      <div className="font-bold text-sm">{operation.name}</div>
    </div>
  );

  return (
    <Dropdown
      trigger={({ expanded: opened }) => (
        <div className="flex gap-2 border px-2 py-1 rounded-md">
          {iconAndName}
          <CaretDownIcon expanded={!!opened} />
        </div>
      )}
      placement="bottom-start"
    >
      <Menu
        className="text-gray-800 max-h-96 overflow-y-auto"
        itemGroups={[
          materialOperations.map(({ name, type }) => ({
            label: (
              <div className="flex items-center gap-1">
                <OperationTypeIcon operationType={type} className="size-4" />
                <span className="ml-2">{name}</span>
              </div>
            ),
            className:
              operation.name === name && operation.type === type
                ? "bg-slate-100 !cursor-not-allowed"
                : "",
            click: () => {
              if (operation.name === name && operation.type === type) return; // no need to re-create the same operation

              deleteOperation({
                params: {
                  path: { id: operation.id, team_slug: teamSlug! },
                },
              });

              createOperation({
                params: { path: { team_slug: teamSlug! } },
                body: {
                  name,
                  type,
                  ordinal: operation.ordinal, // re-create with the same ordinal
                  draft: {},
                  requested_part_rev_id: partId!,
                },
              });
            },
          })),
        ]}
      />
    </Dropdown>
  );
}
